module.exports = __webpack_public_path__ + "static/media/holiday_icon.871d9386.svg";